function formatMoney(cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
}

function buildBlock(product) {
  const shopDataElement = document.getElementById("shop-data");
  const moneyFormat = shopDataElement.dataset.moneyFormat;
  const dividedPrice = product.price / 1.2;
  const timsedPrice = product.price * 1.2;
  const formattedPrice = formatMoney(timsedPrice, moneyFormat);
  const exformattedPrice = formatMoney(product.price, moneyFormat);

  let actionButtonHtml;
  if (product.variants.length > 1) {
    actionButtonHtml = `
          <a href="${product.url}" class="button view-button">View</a>
        `;
  } else {
    actionButtonHtml = `
          <form class="add-to-cart-form" data-product-id="${product.variants[0].id}">
            <input name="id" type="hidden" value="${product.variants[0].id}" />
            <button type="submit"><i class="fa fa-plus" aria-hidden="true"></i> Add</button>
          </form>
        `;
  }

  const html = `
      <div class="related-product" href="${product.url}">
        <a href="${product.url}">
          <img src="${product.images[0]}" />
        </a>
        <a href="${product.url}">  
          <h6>${product.title}</h6>
        </a>
        <div class="price__regular">
          <div class="inc-vat text-body--regular" style="display:flex">
            <span class="visually-hidden visually-hidden--inline">Regular price</span>
            <span class="price-item price-item--regular">${exformattedPrice}</span>
          </div>
        </div>
        ${actionButtonHtml}
      </div>
    `;

  return html;
}

document.addEventListener("DOMContentLoaded", function () {
  const addonForms = document.querySelectorAll(
    ".product__info-container_addon_container .add-to-cart-form"
  );

  addonForms.forEach((form) => {
    const checkbox = form.querySelector('input[type="checkbox"]');
    const addonValue = form.dataset.productAddon || null;
    const linkedAddonInput = form.querySelector(
      'input[name="linked-addon-id"]'
    );
    const linkedAddonId = linkedAddonInput ? linkedAddonInput.value : null;
    const checkboxText = form.querySelector(".addon_checkbox_text");
    const originalText = checkboxText.textContent;
    if (checkbox) {
      checkbox.addEventListener("change", function () {
        const productId = form.dataset.productId;
        const addonValue = checkbox.value;

        const product = {
          id: productId,
          hasAddon: addonValue !== null,
          addonValue: addonValue,
          linkedAddonId: linkedAddonId,
        };

        if (checkbox.checked) {
          addToCart(product, form, originalText);
        } else {
          removeFromCart(product.id, form, originalText);
        }
      });
    }
  });

  const cardIdInput = document.getElementById("card-id");
  const cardId = cardIdInput ? cardIdInput.value : null;

  const notificationIdInput = document.getElementById(
    "notification-product-id"
  );
  const notificationId = notificationIdInput ? notificationIdInput.value : null;

  const productIdInputs = document.querySelectorAll('input[name="product-id"]');
  let productId = null;

  const productAddonInputs = document.querySelectorAll("[data-product-addon]");
  const addonValues = [];
  productAddonInputs.forEach(function (input) {
    const addonValue = input.dataset.productAddon;
    addonValues.push(addonValue);
  });

  if (addonValues.length === 0) {
    for (let i = 0; i < productIdInputs.length; i++) {
      const input = productIdInputs[i];
      if (input.value !== null && input.value.trim() !== "") {
        productId = input.value;
        break;
      }
    }

    let relatedId =
      notificationId !== null
        ? notificationId
        : cardId !== null
        ? cardId
        : productId;

    const complimentaryTitle = document
      .getElementById("complimentary-title")
      .textContent.trim();

    if (
      relatedId !== undefined &&
      relatedId !== null &&
      relatedId.trim() !== ""
    ) {
      const complimentaryProductsContainer = document.querySelector(
        ".complimentary-products_container"
      );

      fetch(
        window.Shopify.routes.root +
          "recommendations/products.json?product_id=" +
          relatedId +
          "&limit=4&intent=complementary"
      )
        .then((response) => {
          if (!response.ok) {
            throw new Error("Failed to fetch complementary products");
          }
          return response.json();
        })
        .then(({ products }) => {
          // Filter out products with metafield `seo.hidden` equal to `1`
          const visibleProducts = products.filter(
            (product) =>
              !(
                product.metafields &&
                product.metafields.seo &&
                product.metafields.seo.hidden == 1
              )
          );
          if (visibleProducts.length === 0) {
            fetch(
              window.Shopify.routes.root +
                "recommendations/products.json?product_id=" +
                relatedId +
                "&limit=4&intent=related"
            )
              .then((response) => {
                if (!response.ok) {
                  throw new Error("Failed to fetch related products");
                }
                return response.json();
              })
              .then(({ products }) => {
                // Filter out products with metafield `seo.hidden` equal to `1`
                const visibleRelatedProducts = products.filter(
                  (product) =>
                    !(
                      product.metafields &&
                      product.metafields.seo &&
                      product.metafields.seo.hidden == 1
                    )
                );
                visibleRelatedProducts.forEach((product) => {
                  const html = buildBlock(product);
                  document.querySelector(".complimentary-products").innerHTML +=
                    html;
                });

                const titleHtml = `<h3>${complimentaryTitle}</h3>`;
                complimentaryProductsContainer.insertAdjacentHTML(
                  "beforebegin",
                  titleHtml
                );
              })
              .catch((error) => {
                console.error("Error fetching related products:", error);
              });
          } else {
            visibleProducts.forEach((product) => {
              const html = buildBlock(product);
              document.querySelector(".complimentary-products").innerHTML +=
                html;
            });

            const titleHtml = `<h3>${complimentaryTitle}</h3>`;
            complimentaryProductsContainer.insertAdjacentHTML(
              "beforebegin",
              titleHtml
            );
          }
        })
        .catch((error) => {
          console.error("Error fetching complementary products:", error);
        });
    }
  }
});

document.addEventListener("submit", function (event) {
    if (event.target && event.target.classList.contains("add-to-cart-form")) {
      event.preventDefault();
      const form = event.target;
      const addButton = form.querySelector('button[type="submit"]');
      const productId = form.dataset.productId;

      const product = {
        id: productId,
      };

      addButton.textContent = "Adding...";
      addButton.disabled = true;

      addToCartComp(product, addButton);

      return false;
    }
  });

function addToCartComp(product, addButton) {
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: product.id,
        quantity: 1,
      }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to add product to cart");
        }
        return response.json();
      })
      .then((data) => {
        addButton.textContent = "Added";
        addButton.classList.add("disabled");
        addButton.disabled = true;
        updateCartCount(1);
      })
      .catch((error) => {
        console.error("Error adding product to cart:", error);
        // Re-enable button in case of error
        addButton.textContent = "Add";
        addButton.disabled = false;
      });
  }

function addToCart(product, form, originalText) {
  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      id: product.id,
      quantity: 1,
      properties: {
        "data-product-addon_type": product.addonValue,
        "data-product-addon_id": product.id,
        "data-linked-addon_id": product.linkedAddonId,
      },
    }),
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error("Failed to add product to cart");
      }
      return response.json();
    })
    .then((data) => {
      const addButton = form.querySelector('button[type="submit"]');
      if (addButton) {
          addButton.textContent = "Added";
          addButton.disabled = true;
          addButton.classList.add("disabled");
      }
      const checkboxText = form.querySelector(".addon_checkbox_text");
      if (checkboxText) {
        const updatedText = `<b>Added!</b> ${checkboxText.textContent.slice(
          4
        )}`;
        checkboxText.innerHTML = updatedText;
      }

      updateCartCount(1);
    })
    .catch((error) => {
      console.error("Error adding product to cart:", error);
    });
}

function removeFromCart(productId, form, originalText) {
  fetch(`/cart/change.js`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      id: productId,
      quantity: 0,
    }),
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error("Failed to remove product from cart");
      }
      return response.json();
    })
    .then((data) => {
      const addButton = form.querySelector('button[type="submit"]');
      if (addButton) {
        addButton.textContent = "Subscribe";
        addButton.disabled = false;
        addButton.classList.remove("disabled");
      }

      const checkboxText = form.querySelector(".addon_checkbox_text");
      if (checkboxText) {
        checkboxText.textContent = originalText;
      }

      updateCartCount(-1);
    })
    .catch((error) => {
      console.error("Error removing product from cart:", error);
    });
}

function updateCartCount(count) {
  const cartCountBubbles = document.querySelectorAll(
    "#cart-icon-bubble .cart-count-bubble"
  );

  cartCountBubbles.forEach((cartCountBubble) => {
    const cartCountSpan = cartCountBubble.querySelector(
      'span[aria-hidden="true"]'
    );

    let visuallyHiddenText = cartCountBubble.querySelector(".visually-hidden");
    if (!visuallyHiddenText) {
      visuallyHiddenText = document.createElement("span");
      visuallyHiddenText.className = "visually-hidden";
      cartCountBubble.appendChild(visuallyHiddenText);
    }

    if (cartCountSpan && visuallyHiddenText) {
      const currentCount = parseInt(cartCountSpan.textContent || 0);
      const newCount = currentCount + count;

      if (newCount < 100) {
        cartCountSpan.textContent = newCount;
        visuallyHiddenText.textContent = `Cart count: ${newCount}`;
        visuallyHiddenText.setAttribute("aria-hidden", "false");
      } else {
        cartCountBubble.innerHTML = "";
        visuallyHiddenText.textContent = `Cart count: 100+`;
        visuallyHiddenText.setAttribute("aria-hidden", "false");
      }
    }
  });
}
